import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { getSafevaultSiteUrls } from '../utils/safevaultSiteUrls';
import { SAFEVAULT_BRAND } from '../theme/safevaultBrand';

const BRAND_COPY = {
    safevault: {
        headline: 'Ready to organize important documents before you need them?',
        body: 'Explore SafeVault or contact our team to see how secure document workflows can support families, professionals, and service providers.',
    },
    cliqloan: {
        headline: 'Want a clearer lending workflow from application to closing?',
        body: 'Explore CliQloan or contact our team to see how better document visibility and borrower coordination can help reduce delays.',
    },
    amitasoft: {
        headline: 'Looking to bring more clarity and control to complex workflows?',
        body: 'Explore AmitaSoft products or contact our team to discuss how our platforms support document, lending, and operational workflows.',
    },
};

const BlogArticleCta = ({ variant = 'safevault' }) => {
    const urls = getSafevaultSiteUrls();
    const copy = BRAND_COPY[variant] || BRAND_COPY.safevault;

    const productsUrl =
        variant === 'cliqloan'
            ? `${urls.cliqloanHome}/our-products`
            : variant === 'amitasoft'
              ? `${urls.amitasoftHome}/our-products`
              : urls.ourProducts;

    const contactUrl =
        variant === 'cliqloan'
            ? `${urls.cliqloanHome}/contact-us`
            : variant === 'amitasoft'
              ? `${urls.amitasoftHome}/contact-us`
              : urls.contactUs;

    return (
        <Box
            className="blog-article-cta"
            sx={{
                mt: 5,
                p: { xs: 3, md: 4 },
                borderRadius: 2,
                backgroundColor: SAFEVAULT_BRAND.lightGray,
                border: `1px solid ${SAFEVAULT_BRAND.deepPurple}14`,
            }}
        >
            <Typography
                component="h2"
                sx={{
                    mb: 1.5,
                    color: SAFEVAULT_BRAND.deepPurple,
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    fontSize: 'clamp(1.125rem, 2vw, 1.375rem)',
                    lineHeight: 1.3,
                }}
            >
                {copy.headline}
            </Typography>
            <Typography
                sx={{
                    mb: 3,
                    color: '#4C5270',
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '1rem',
                    lineHeight: 1.65,
                }}
            >
                {copy.body}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Button
                    component="a"
                    href={productsUrl}
                    variant="contained"
                    sx={{
                        backgroundColor: SAFEVAULT_BRAND.deepPurple,
                        textTransform: 'none',
                        fontWeight: 600,
                        '&:hover': { backgroundColor: '#3432C7' },
                    }}
                >
                    Explore Products
                </Button>
                <Button
                    component="a"
                    href={contactUrl}
                    variant="outlined"
                    sx={{
                        borderColor: SAFEVAULT_BRAND.deepPurple,
                        color: SAFEVAULT_BRAND.deepPurple,
                        textTransform: 'none',
                        fontWeight: 600,
                    }}
                >
                    Contact Us
                </Button>
            </Box>
        </Box>
    );
};

export default BlogArticleCta;
